import { useTranslation } from "react-i18next";
import { statusColor } from "./lib";
import { Tag } from "@qivia/ui";

type Status = "ACTIVE" | "PENDING" | "DEACTIVATED" | "EXPIRED" | "CANCELED";
const statusEnum = ["ACTIVE", "PENDING", "DEACTIVATED", "EXPIRED", "CANCELED"];

export const StatusColorDict = (props: { status: string }) => {
  const { t } = useTranslation();
  const statusTranslated = statusEnum.find(
    (s) => t(`users.management.status.${s}`) === props.status,
  );
  if (!statusTranslated) {
    return "";
  }

  const result = statusColor[statusTranslated as Status];
  return (
    <Tag
      text={props.status}
      backgroundColor={result.backgroundColor}
      textColor={result.textColor}
    />
  );
};
